import React, { PropsWithChildren } from "react";
import styled from "styled-components";

type FilterChipProps = React.ElementRef<"input"> & {
  color?: string;
};

export const StyledFilterChip = styled.div<
  Partial<Pick<FilterChipProps, "checked">>
>`
  --color: ${(props) => props.color || "#333"};

  border: solid 1px var(--color);
  height: 3rem;
  display: flex;
  align-items: center;
  padding: 1rem;
  box-sizing: border-box;
  border-radius: 1.5rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  color: var(--color);

  &:hover {
    background-color: #f5f5f5;
  }

  ${(props) =>
    props.checked &&
    `
    background-color: var(--color);
    border-color: var(--color);
    color: #fff;

    &:hover {
      background-color: var(--color);
    }
  `}
`;

export const FilterChip = ({
  children,
  ...props
}: React.PropsWithChildren<{
  value?: string;
  color?: string;
  checked?: boolean;
}>) => {
  return (
    <StyledFilterChip {...props} checked={props.checked}>
      {children}
    </StyledFilterChip>
  );
};

const StyledFilterChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.7rem;
`;

const FilterChips: React.FC<
  React.PropsWithChildren<
    PropsWithChildren<{
      value?: string[];
      onChange?: (value: string[]) => void;
    }>
  >
> = (props) => {
  return (
    <StyledFilterChips>
      {props.children &&
        React.Children.map(props.children, (child: any, idx) => {
          if (!child) return;
          return React.cloneElement(child, {
            key: idx,
            checked: props.value?.includes(child.props.value) ? true : false,
            onClick: () => {
              const values = Array.from(new Set([...(props.value ?? [])]));
              const idx = values.indexOf(child.props.value);
              if (idx === -1) {
                values.push(child.props.value);
              } else {
                values.splice(idx, 1);
              }
              props.onChange?.(values);
            },
            ...child.props,
          });
        })}
    </StyledFilterChips>
  );
};

export default FilterChips;
